module.exports = __webpack_public_path__ + "img/three-dots-vertical.42fec6a7.svg";